/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NodataReturnGoodsDto
 */
export interface NodataReturnGoodsDto {
    /**
     * 历史商品ID。
     * @type {number}
     * @memberof NodataReturnGoodsDto
     */
    id?: number;
    /**
     * 历史订单ID。
     * @type {number}
     * @memberof NodataReturnGoodsDto
     */
    sourceOrderId?: number;
    /**
     * 历史订单编号。
     * @type {string}
     * @memberof NodataReturnGoodsDto
     */
    orderCode?: string;
    /**
     * 商品名称。
     * @type {string}
     * @memberof NodataReturnGoodsDto
     */
    name?: string;
    /**
     * 商品图片。
     * @type {string}
     * @memberof NodataReturnGoodsDto
     */
    imgUrl?: string;
    /**
     * 历史颜色。
     * @type {string}
     * @memberof NodataReturnGoodsDto
     */
    color?: string;
    /**
     * 历史规格。
     * @type {string}
     * @memberof NodataReturnGoodsDto
     */
    size?: string;
    /**
     * 历史平台条码。
     * @type {string}
     * @memberof NodataReturnGoodsDto
     */
    marketBarcode?: string;
    /**
     * 历史平台商品名。
     * @type {string}
     * @memberof NodataReturnGoodsDto
     */
    marketProNm?: string;
    /**
     * 历史平台选项名。
     * @type {string}
     * @memberof NodataReturnGoodsDto
     */
    marketOptionName?: string;
    /**
     * 历史平台选项ID。
     * @type {string}
     * @memberof NodataReturnGoodsDto
     */
    marketOptionId?: string;
    /**
     * 是否为合包父商品。
     * @type {number}
     * @memberof NodataReturnGoodsDto
     */
    combined?: number;
    /**
     * 历史申请数量。
     * @type {number}
     * @memberof NodataReturnGoodsDto
     */
    initQuantity?: number;
    /**
     * 每套构成数量。
     * @type {number}
     * @memberof NodataReturnGoodsDto
     */
    constructCount?: number;
    /**
     * 历史合包基础商品。
     * @type {Array<NodataReturnGoodsDto>}
     * @memberof NodataReturnGoodsDto
     */
    baseGoods?: Array<NodataReturnGoodsDto>;
}

/**
 * Check if a given object implements the NodataReturnGoodsDto interface.
 */
export function instanceOfNodataReturnGoodsDto(value: object): value is NodataReturnGoodsDto {
    return true;
}

export function NodataReturnGoodsDtoFromJSON(json: any): NodataReturnGoodsDto {
    return NodataReturnGoodsDtoFromJSONTyped(json, false);
}

export function NodataReturnGoodsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NodataReturnGoodsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'sourceOrderId': json['sourceOrderId'] == null ? undefined : json['sourceOrderId'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'name': json['name'] == null ? undefined : json['name'],
        'imgUrl': json['imgUrl'] == null ? undefined : json['imgUrl'],
        'color': json['color'] == null ? undefined : json['color'],
        'size': json['size'] == null ? undefined : json['size'],
        'marketBarcode': json['marketBarcode'] == null ? undefined : json['marketBarcode'],
        'marketProNm': json['marketProNm'] == null ? undefined : json['marketProNm'],
        'marketOptionName': json['marketOptionName'] == null ? undefined : json['marketOptionName'],
        'marketOptionId': json['marketOptionId'] == null ? undefined : json['marketOptionId'],
        'combined': json['combined'] == null ? undefined : json['combined'],
        'initQuantity': json['initQuantity'] == null ? undefined : json['initQuantity'],
        'constructCount': json['constructCount'] == null ? undefined : json['constructCount'],
        'baseGoods': json['baseGoods'] == null ? undefined : ((json['baseGoods'] as Array<any>).map(NodataReturnGoodsDtoFromJSON)),
    };
}

export function NodataReturnGoodsDtoToJSON(json: any): NodataReturnGoodsDto {
    return NodataReturnGoodsDtoToJSONTyped(json, false);
}

export function NodataReturnGoodsDtoToJSONTyped(value?: NodataReturnGoodsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'sourceOrderId': value['sourceOrderId'],
        'orderCode': value['orderCode'],
        'name': value['name'],
        'imgUrl': value['imgUrl'],
        'color': value['color'],
        'size': value['size'],
        'marketBarcode': value['marketBarcode'],
        'marketProNm': value['marketProNm'],
        'marketOptionName': value['marketOptionName'],
        'marketOptionId': value['marketOptionId'],
        'combined': value['combined'],
        'initQuantity': value['initQuantity'],
        'constructCount': value['constructCount'],
        'baseGoods': value['baseGoods'] == null ? undefined : ((value['baseGoods'] as Array<any>).map(NodataReturnGoodsDtoToJSON)),
    };
}

